import PropTypes from 'prop-types';
import React from 'react';

function Estimate(props) {
  const { fill } = props;
  return (
    <svg
      height="24"
      style={{ fill: 'none' }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.79981 1.82498H16.1998C17.5115 1.82498 18.5748 2.88831 18.5748 4.19998V19.8C18.5748 21.1117 17.5115 22.175 16.1998 22.175H7.79981C6.48813 22.175 5.4248 21.1117 5.4248 19.8V4.19999C5.4248 2.88831 6.48813 1.82498 7.79981 1.82498Z"
        stroke={fill}
        strokeWidth="1.25"
      />
      <path
        d="M8.4002 5.42502H15.6002C15.9178 5.42502 16.1752 5.68245 16.1752 6.00002V9.60002C16.1752 9.91758 15.9178 10.175 15.6002 10.175H8.40019C8.08263 10.175 7.8252 9.91758 7.8252 9.60002V6.00002C7.8252 5.68245 8.08263 5.42502 8.4002 5.42502Z"
        stroke={fill}
        strokeWidth="1.25"
      />
      <rect fill={fill} height="1.8" rx="0.9" width="1.8" x="7.7998" y="16.2" />
      <rect fill={fill} height="1.8" rx="0.9" width="1.8" x="7.7998" y="12.6" />
      <rect fill={fill} height="1.8" rx="0.9" width="1.8" x="11.1001" y="16.2" />
      <rect fill={fill} height="1.8" rx="0.9" width="1.8" x="11.1001" y="12.6" />
      <rect fill={fill} height="1.8" rx="0.9" width="1.8" x="14.3999" y="16.2" />
      <rect fill={fill} height="1.8" rx="0.9" width="1.8" x="14.3999" y="12.6" />
    </svg>
  );
}

Estimate.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Estimate;
